import { 
    ApprovazioneFeriePage, CalendarioLavoriPage, HomePage, LavoriPage, RichiestaFeriePage, 
    SituazioneCommessePage, PianoFeriePage, RiepilogoGiustificativiPage,
    CaricaGiustificativiPage
} from './pages';
import { withNavigationWatcher } from './contexts/navigation';

// Parte di plugin
import { ATS_RapportiniPage } from './plugins/ATS/pages';

const routes = [
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/lavori',
        element: LavoriPage
    },
    {
        path: 'calendario-lavori',
        element: CalendarioLavoriPage
    },
    {
        path: '/riepilogo-giustificativi',
        element: RiepilogoGiustificativiPage
    },
    {
        path: '/rapportini',
        element: ATS_RapportiniPage
    },
    {
        path: '/situazione-commesse',
        element: SituazioneCommessePage
    },
    {
        path: '/richiesta-ferie',
        element: RichiestaFeriePage
    },
    {
        path: '/approvazione-ferie',
        element: ApprovazioneFeriePage
    },
    {
        path: '/piano-ferie',
        element: PianoFeriePage
    },
    {
        path: '/carica-giustificativi',
        element: CaricaGiustificativiPage
    }
];

export const appRoutes = routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});

